var slideout = new Slideout({
  'panel': document.getElementById('page-wrapper'),
  'menu': document.getElementById('slider-nav'),
  'padding': 256,
  'tolerance': 70
});

// Toggle button
document.querySelector('.toggle-button').addEventListener('click', function() {
  slideout.toggle();
  $(".menu-toggle").toggleClass('open');
  $("#page-wrapper").toggleClass('slide-open');
});

window.addEventListener('resize', function(){
  slideout.close();
}, true);

/**
 * Open all external links in a new window
 */
jQuery(document).ready(function($) {
  $('a')
    .filter('[href^="http"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('rel', 'noopener noreferrer')
    .attr('target', '_blank');
});

// START Document Ready
(function($) {
	"use strict";
	$(document).ready(function() {

    //Polaraid photo fader
    $(".photoSlider .photo").hide();
  	photoSlider();

		var modalhtml = '<div class="modal" id="myProfile"><div class="modal-dialog"><div class="modal-content"><button type="button" class="close" data-dismiss="modal">&times;</button><div class="modal-body"></div></div></div></div>';
		$('body').has('section.teamgrid').append(modalhtml);

    // $("figure.wp-block-image").each(function(){
    //   $(this).parent('.wp-block-column').addClass("alignMiddle");
    //   console.log($(this));
    // });


    // $("img[data-name='image']").each(function(){
    //   if ($(this).width() > $(this).height()) {
    //       $(this).addClass("horizontal");
    //   }
    // });


		$('div.teamMember[data-content-id]').click(function(e) {
      e.preventDefault();
			var content_id = $(this).data('content-id');
			console.log( content_id );
			var teamMember_all = $('div.teamMember[data-content-id]');
			var teamMember = $(this);
			$.ajax({
				url : Ajax_object.ajax_url,
				type : 'post',
				data : {
					action : 'post_team_profile_data',
					content_id : content_id
				},
				success : function( response ) {
					// show_success( response );
					//
					$('#myProfile').modal('show');
					$('#myProfile div.modal-body').html(response);

				}
			});
		})

//
    // dont' make me add the class, let js do it for me
    $("a:contains('Learn More')").addClass("learnMore");


//  Social sharing linnks to popout window on big displays of new url

    $('a[data-socialshare]').click(function(e) {
      if ($(window).width() > 780) {
        e.preventDefault();
        var link = $(this).attr('href');
        console.log( link );
        window.open(link,null,"height=400,width=550,status=yes,toolbar=no,menubar=no,location=no");
      }
    })


    // $("#dialog").dialog({
    //        modal: true,
    //        height: 400,
    //        width: 550
    //    });

// jQuery.ajax({
//     type: "post",
//     dataType: "json",
//     url: Ajax_object.ajax_url,
//     data: get_team_profile_data,
//     success: function(msg){
//         console.log(msg);
//     }
// });

});//ENDDOCUMENTREADY
})(jQuery);

function photoSlider(){
  $(".photoSlider").each(function(){
    var currentPhoto = $(this).find(".currentPhoto");
  	if( currentPhoto.length == 0 ){ // for first load only
  		$(this).find(".photo:first").addClass("currentPhoto");
  		$(this).find(".currentPhoto").show();
  	} else {
  		if( currentPhoto.next(".photo").length == 0 ){
  			var nextPhoto = $(this).find(".photo:first");
  		} else {
  			var nextPhoto = $(this).find(".currentPhoto").next(".photo");
  		}
  		currentPhoto.fadeOut(1500,function(){
  			$(this).removeClass("currentPhoto");
  		});
  		nextPhoto.fadeIn(1500,function(){
  			$(this).addClass("currentPhoto");
  		});
  		/*$(".currentPhoto").animate({
  			"top":"-355px"
  		}, function(){
  			$(this).removeClass("currentPhoto").css("top","355px");
  		});
  		nextPhoto.animate({
  			"top":"0px"
  		}, function(){
  			$(this).addClass("currentPhoto");
  		});*/
  	}
  });
	setTimeout("photoSlider()",8000);
}
